import { useState } from 'react'
import Topbar from '../components/layout/Topbar'
import Button from '../components/shared/Button'
import Input from '../components/shared/Input'
import { useToast } from '../components/shared/Toast'
import { useAppStore } from '../store/useAppStore'

export default function Settings() {
  const { user } = useAppStore()
  const toast = useToast()
  const [loading, setLoading] = useState(false)

  const [formData, setFormData] = useState({
    display_name: user?.display_name ?? '',
    email: user?.email ?? '',
    bio: user?.bio ?? '',
    current_password: '',
    new_password: '',
    confirm_password: ''
  })

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const handleSaveProfile = () => {
    try {
      setLoading(true)
      // TODO: API call
      toast.success('Profil guncellendi')
    } catch (_error) {
      toast.error('Profil guncellenemedi')
    } finally {
      setLoading(false)
    }
  }

  const handleChangePassword = () => {
    if (formData.new_password !== formData.confirm_password) {
      toast.error('Sifreler eslesmiyor')
      return
    }

    try {
      setLoading(true)
      // TODO: API call
      toast.success('Sifre degistirildi')
      setFormData(prev => ({ ...prev, current_password: '', new_password: '', confirm_password: '' }))
    } catch (_error) {
      toast.error('Sifre degistirilemedi')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>      <div style={{ flex: 1, overflow: 'auto' }}>
        <Topbar />
        <div style={{ flex: 1, overflow: 'auto', padding: '2rem' }}>
          <div style={{ maxWidth: '800px', margin: '0 auto' }}>
            <h1>Ayarlar</h1>

            {/* Profil Ayarlari */}
            <div style={{ marginBottom: '2rem', padding: '1.5rem', background: 'var(--bg-secondary)', borderRadius: '12px' }}>
              <h2 style={{ marginBottom: '1.5rem' }}>Profil Bilgileri</h2>
              <Input
                label="Goruntulenen Ad"
                name="display_name"
                value={formData.display_name}
                onChange={handleChange}
                fullWidth
              />
              <Input
                label="Email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                fullWidth
              />
              <Input
                as="textarea"
                label="Biyografi"
                name="bio"
                value={formData.bio}
                onChange={handleChange}
                fullWidth
                rows={4}
              />
              <Button onClick={() => void handleSaveProfile()} loading={loading} variant="primary">
                Kaydet
              </Button>
            </div>

            {/* Sifre Degistir */}
            <div style={{ padding: '1.5rem', background: 'var(--bg-secondary)', borderRadius: '12px' }}>
              <h2 style={{ marginBottom: '1.5rem' }}>Sifre Degistir</h2>
              <Input
                label="Mevcut Sifre"
                name="current_password"
                type="password"
                value={formData.current_password}
                onChange={handleChange}
                fullWidth
              />
              <Input
                label="Yeni Sifre"
                name="new_password"
                type="password"
                value={formData.new_password}
                onChange={handleChange}
                fullWidth
              />
              <Input
                label="Yeni Sifre (Tekrar)"
                name="confirm_password"
                type="password"
                value={formData.confirm_password}
                onChange={handleChange}
                fullWidth
              />
              <Button onClick={() => void handleChangePassword()} loading={loading} variant="primary">
                Sifre Degistir
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
